import { Input as BaseInput, Error, ErrorConnector, HelpText, Label, RequiredStar } from "../common";
import React from "react";
import { SharedInputProps } from "../Input";
import styled from "styled-components";
export type TextProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & SharedInputProps;
const TextArea = styled(BaseInput).attrs({
  as: "textarea"
})`
  display: block;
  resize: none;
  width: 100%;
`;
const TextInput = styled(BaseInput).attrs({
  as: "input"
})`
  width: 100%;
`;
export function Text({
  error,
  helpText,
  label,
  ...props
}: TextProps) {
  const {
    id,
    required,
    rows
  } = props;
  const hasError = !!error;
  return <>
      <Label htmlFor={id} data-sentry-element="Label" data-sentry-source-file="Text.tsx">
        {label}
        {label && required ? <RequiredStar /> : null}
      </Label>
      <HelpText data-sentry-element="HelpText" data-sentry-source-file="Text.tsx">{helpText}</HelpText>
      <Container data-sentry-element="Container" data-sentry-source-file="Text.tsx">
        <ErrorConnector show={hasError} data-sentry-element="ErrorConnector" data-sentry-source-file="Text.tsx">
          {rows && rows > 0 ? <TextArea rows={rows} error={hasError} aria-required={required} {...props} /> : <TextInput error={hasError} aria-required={required} {...props} />}

          {error ? <Error role="alert">{error}</Error> : null}
        </ErrorConnector>
      </Container>
    </>;
}
const Container = styled.div`
  width: 100%;
`;
export default Text;